/**
 * Created by jhcao on 2020/05/11.
 * 公式识别示例JSON数据
 */
var bgImageList = [
  {
    url: 'https://cdn.aidaxue.com/formula_discern/case/example-04.jpg',
    result: ['  S_ {\\triangle }  =  \\sqrt {p(p-a)(p-b)(p-c)}  ']
  },
  {
    url: 'https://cdn.aidaxue.com/formula_discern/case/example-05.jpg',
    result: ['  \\log _ {a}  N=  \\frac {\\log _ {b}N}{\\log _ {b}a}  =  \\frac {\\ln N}{\\ln a}  =  \\frac {\\lg N}{\\lg a}  ']
  },
  {
    url: 'https://cdn.aidaxue.com/formula_discern/case/example-03.jpg',
    result: ['12.函数f(x)=\\sin\\frac{x}{2}\\cos\\frac{x}{2}+\\cos^{2}\\frac{x}{2},当x\\in(0,\\frac{\\pi}{2})时,f(x)的值域为\\_.']
  }
]

function formulaData () {
  return bgImageList
}

export { formulaData }



// WEBPACK FOOTER //
// ./src/js/libs/json/formula-discern.js